import { render, staticRenderFns } from "./NsTopnavGivingBack.vue?vue&type=template&id=318f32fa&scoped=true&"
import script from "./NsTopnavGivingBack.vue?vue&type=script&lang=js&"
export * from "./NsTopnavGivingBack.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavGivingBack.vue?vue&type=style&index=0&id=318f32fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f32fa",
  null
  
)

export default component.exports